"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Modal = require("@insided/shared/uikit/Modal");

var _index = _interopRequireDefault(require("../button-control/index"));

var _BadgeSelector = _interopRequireDefault(require("../badges/BadgeSelector"));

var _axios = _interopRequireDefault(require("axios"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RevokeBadgeModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(RevokeBadgeModal, _Component);

  var _super = _createSuper(RevokeBadgeModal);

  function RevokeBadgeModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RevokeBadgeModal);
    _this = _super.call(this, props);
    _this.state = {
      badgesList: null,
      selectedBadge: null,
      isModalOpen: true
    };
    _this.revokeBadge = _this.revokeBadge.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBadgeSelected = _this.onBadgeSelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.trackBadgeAwardedEvent = _this.trackBadgeAwardedEvent.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(RevokeBadgeModal, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get("/settings/badge/getBadgesList?userid=".concat(this.props.userId));

              case 2:
                response = _context.sent;
                this.setState({
                  badgesList: response.data
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "revokeBadge",
    value: function () {
      var _revokeBadge = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this2 = this;

        var selectedBadge, userId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectedBadge = this.state.selectedBadge;
                userId = this.props.userId;

                if (selectedBadge) {
                  _context2.next = 5;
                  break;
                }

                this.setState({
                  error: 'Please select a badge'
                });
                return _context2.abrupt("return");

              case 5:
                _context2.prev = 5;
                _context2.next = 8;
                return _axios.default.post('/settings/badge/revoke', {
                  badgeId: selectedBadge,
                  userId: userId
                }).then(function () {
                  _this2.trackBadgeAwardedEvent(selectedBadge);

                  _this2.closeModal();

                  window.location.reload();
                });

              case 8:
                _context2.next = 12;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](5);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 10]]);
      }));

      function revokeBadge() {
        return _revokeBadge.apply(this, arguments);
      }

      return revokeBadge;
    }()
  }, {
    key: "trackBadgeAwardedEvent",
    value: function trackBadgeAwardedEvent(selectedBadge) {
      var badgesList = this.state.badgesList;
      var _this$props = this.props,
          revokerId = _this$props.revokerId,
          revokerUsername = _this$props.revokerUsername,
          revokerRole = _this$props.revokerRole,
          userId = _this$props.userId,
          userName = _this$props.userName,
          userRole = _this$props.userRole;
      if (!badgesList) return;
      var revokedBadge = badgesList.find(function (badge) {
        return badge.id.toString() === selectedBadge;
      });
      if (!revokedBadge) return;

      _publish.default.trackEvent('userevent', {
        type: 'Badge Revoked',
        badgeId: revokedBadge.id,
        badgeName: revokedBadge.title,
        badgeDescription: revokedBadge.description,
        revokerId: revokerId,
        revokerUsername: revokerUsername,
        revokerRole: revokerRole,
        revokedId: userId,
        revokedUsername: userName,
        revokedRole: userRole
      });
    }
  }, {
    key: "getSelectedBadge",
    value: function getSelectedBadge() {
      var _this$state = this.state,
          badgesList = _this$state.badgesList,
          selectedBadge = _this$state.selectedBadge;
      if (!badgesList) return;
      return badgesList.find(function (badge) {
        return badge.id.toString() === selectedBadge;
      });
    }
  }, {
    key: "onBadgeSelected",
    value: function onBadgeSelected(badgeId) {
      this.setState({
        selectedBadge: badgeId,
        error: undefined
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        isModalOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var state = this.state;
      if (!state.badgesList) return null;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: state.isModalOpen
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Revoke badge",
        onClose: function onClose() {
          return _this3.closeModal();
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)(_BadgeSelector.default, {
        badges: state.badgesList,
        selected: this.getSelectedBadge(),
        onChange: this.onBadgeSelected,
        error: state.error
      })), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_index.default, {
        title: "Revoke",
        variant: "primary",
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", _this3.revokeBadge());

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))
      }), (0, _preact.h)(_index.default, {
        title: "Cancel",
        onClick: function onClick() {
          return _this3.closeModal();
        }
      })));
    }
  }]);
  return RevokeBadgeModal;
}(_preact.Component);

var _default = RevokeBadgeModal;
exports.default = _default;